<template>
  <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      :retain-focus="false"
      persistent
      transition="dialog-bottom-transition">
      <template v-slot:activator="{ on, attrs }">
          <v-btn 
            v-bind="attrs"
            v-on="on" 
            rounded 
            color="primary"
            dark>
              Marca Empresarial
          </v-btn>
      </template>
      <v-card>
        <v-toolbar
          dark
          color="secondary">
              <v-btn
                  icon
                  dark
                  class="btn btn-primary"
                  @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>
                {{ data.hasBusinessBranding ? "Detalle Marca Empresarial" : "Agregar Marca Empresarial" }}
              </v-toolbar-title>
          </v-toolbar>
        <agregarMarcaEmpresarial/>
      </v-card>
  </v-dialog>

</template>

<script>
import agregarMarcaEmpresarial from '@/views/marca_empresarial/pages/components/agregar_marca_empresarial.vue';
import  EventBus  from '@/utils/event_bus.js'; 

export default {
  name:"marcaEmpresarial",
  components: {
    agregarMarcaEmpresarial
  },
  props: {
    data: {
      required: true
    },
  },
  data () {
    return {
      dialog: false
    }
  },
  mounted() {
    EventBus.$on('marca-succesfull', () => {
      this.dialog = false;
    });
    EventBus.$on('marca-error', () => {
      this.dialog = true;
    });
  },
};
</script>

<style lang="css" scoped>
</style>
